import { m } from "framer-motion";
import PropTypes from "prop-types";
// @mui
import { Container, Typography } from "@mui/material";
// components
import { useSelector } from "react-redux";
import { MotionContainer, varBounce } from "../components/animate";
// assets
import { ForbiddenIllustration } from "../assets/illustrations";
//
import { HQ_SUB_DISTRIBUTOR_ID } from "../constants/distributors";
// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  hasContent: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
  distributors: PropTypes.arrayOf(PropTypes.string),
  subDistributors: PropTypes.arrayOf(PropTypes.string),
};

export default function RoleBasedGuard({ hasContent, roles, distributors, subDistributors, children }) {
  const selectedRole = useSelector((state) => state.auth.selectedRole);

  // Guard against null selectedRole during logout/init race conditions
  if (!selectedRole) {
    return null;
  }

  const { customer_name, sub_distributor_id } = selectedRole;
  const currentRole = selectedRole.role;

  // Check if the user's role matches any of the allowed roles
  const hasRoleAccess = roles ? roles.includes(currentRole) : true;

  // Check if distributor access is restricted to specific distributors
  // For distributors: check if their customer_name is in the distributors list
  // For sub-distributors: also check if their parent distributor (customer_name) is in the distributors list
  const hasDistributorAccess =
    distributors && distributors.length > 0 && (currentRole === "distributor" || currentRole === "sub-distributor")
      ? distributors.includes(customer_name)
      : true;

  const hasSubDistributorAccess =
    currentRole === "sub-distributor" && subDistributors && subDistributors.length > 0
      ? subDistributors.includes(customer_name) && sub_distributor_id !== HQ_SUB_DISTRIBUTOR_ID
      : true;

  // Deny access if the user does not meet the role or distributor criteria
  if (!hasRoleAccess || !hasDistributorAccess || !hasSubDistributorAccess) {
    // if (!hasRoleAccess || !hasDistributorAccess) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: "center" }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: "text.secondary" }}>You do not have permission to access this page</Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <> {children} </>;
}
